module.exports = __webpack_public_path__ + "img/w54.a1d8a962.svg";